import React from "react"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import ContractsTable from "./ContractsTable"
import { useTranslation } from "react-i18next"

export default function MyContractsList() {

  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("Contracts")} />
        <ContractsTable />
      </div>
    </div>
  )
}
